import { useState, useEffect, useCallback } from 'react'
import HPOFilter from 'src/views/VariantsView/Toolbar/FiltersPanelMenu/HPOFilter'
import useHPOSelection from 'src/hooks/useHPOSelection'
import { Box, Typography } from '@material-ui/core'

/**
 * A wrapper component for HPOFilter to be used in AnnotationDialog and later
 * in FiltersPanelMenu (not refactored yet). `compact` is the New analysis panel's
 * single search box; `inputId` sets the id of its search input.
 */
const HPOFilterWrapper = ({
  value = [],
  onChange,
  stringOutput = false,
  arrayOutput = false,
  label = 'HPO Terms',
  compact = false,
  inputId,
}) => {
  const handleTermsChange = useCallback(
    (terms) => {
      if (onChange) {
        if (arrayOutput) {
          const getIds = (terms) => {
            if (!terms || terms.length === 0) return []
            return terms.map((term) => term.hpo_id)
          }

          const getNames = (terms) => {
            if (!terms || terms.length === 0) return []
            return terms.map((term) => term.name)
          }

          onChange({
            hpos: getIds(terms),
            hpoNames: getNames(terms),
            hpoTerms: terms || [], // Include full term objects with all metadata
          })
        } else if (stringOutput) {
          // String output is used for FilterPanelMenu i think
          const asString = terms.length > 0 ? terms.map((term) => term.hpo_id).join(', ') : ''
          onChange(asString)
        } else {
          onChange(terms)
        }
      }
    },
    [onChange, stringOutput, arrayOutput],
  )

  const { hpoTerms, setHpoTerms, setHpoTermsFromString } = useHPOSelection([], handleTermsChange)

  // Handle incoming value changes
  useEffect(() => {
    // Skip if current value matches incoming value
    if (typeof value === 'string' && value !== hpoTerms.map((t) => t.hpo_id).join(', ')) {
      setHpoTermsFromString(value)
    } else if (Array.isArray(value) && JSON.stringify(value) !== JSON.stringify(hpoTerms)) {
      setHpoTerms(value)
    }
  }, [value, hpoTerms, setHpoTermsFromString, setHpoTerms])

  return (
    <Box>
      {label && (
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          {label}
        </Typography>
      )}
      <HPOFilter hpoTerms={hpoTerms} setHpoTerms={setHpoTerms} compact={compact} inputId={inputId} />
    </Box>
  )
}

export default HPOFilterWrapper
